<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-level="10000" :back-url="backurl" />
    <van-skeleton title avatar :row="20" :loading="loading">
      <div v-if="data" class="baseRest">
        <van-row>
          <van-col span="16"><div :style="'color:'+GetDiveMainBack()" @click="hideAbout =!hideAbout">{{ data.courseName }}<span v-if="data.nameShort">({{ data.nameShort }})</span></div></van-col>
          <van-col span="8" class="rigth" @click="hideAbout =!hideAbout"><i :class="hideAbout?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
        </van-row>
        <div v-if="!hideAbout" class="about">
          {{ data.about }}
        </div>
        <van-row class="center">
          <van-col span="8" class="topLine" :style="'color:'+GetDiveMainBack()"><div class="lineName">类型/国家</div>
            {{ data.typeName }}
          </van-col>
          <van-col span="8" class="topLine" :style="'color:'+GetDiveMainBack()"><div class="lineName">最后更新时间</div>
            {{ data.lastUpdateTime?formatDate(data.lastUpdateTime,'yyyy/MM/dd hh:mm',true):'-' }}
          </van-col>
          <van-col span="8" class="topLine" :style="'color:'+GetDiveMainBack()"><div class="lineName">当前进度</div>
            {{ GetEnumText("Em_LearningState",data.studentInfo.state) }}
          </van-col>
        </van-row>
      <!--
      <van-row>
        <van-col span="8" class="name">状态</van-col>
        <van-col span="16" class="value rigth">待开课</van-col>
      </van-row>
      <van-row>
        <van-col span="8" class="name">分类</van-col>
        <van-col span="16" class="value rigth">水肺课程</van-col>
      </van-row> -->
      </div>

      <div v-if="data" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideDiveOrder =!hideDiveOrder">行程订单</div></van-col>
          <van-col v-if="hideDiveOrder" span="16" class="rigth" @click="hideDiveOrder =!hideDiveOrder">
            <i :class="hideDiveOrder?'iconfont icondownjt':'iconfont iconupjt'" />
          </van-col>
          <van-col v-if="!hideDiveOrder" span="16" class="rigth" @click="hideDiveOrder =!hideDiveOrder"><i :class="hideDiveOrder?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
        </van-row>
        <div v-if="!hideDiveOrder" style="margin-top:0.5em">
          <van-row>
            <van-col span="12">
              <div class="lineValue breakAll">行程号:<span> {{ data.diveOrder.diveOrderId }}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">潜水中心:<span> {{ data.diveStoreName }}</span></div>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="12">
              <div class="lineValue">预订人:<span> {{ data.diveOrder.bookName }}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue">预定时间:<span> {{ formatDate(data.diveOrder.craeteTime,"yyyy/MM/dd hh:mm",true) }}</span></div>
            </van-col>
            <van-col span="12" v-if="data.studentInfo && data.studentInfo.startTime" >
              <div class="lineValue">出行日期:<span> {{ formatDate(data.studentInfo.startTime,"yyyy/MM/dd") }}</span></div>
            </van-col>
            <van-col span="12" v-if="data.studentInfo && data.studentInfo.subTitle" >
              <div class="lineValue breakAll">房型:<span> {{ data.studentInfo.subTitle }}</span></div>
            </van-col>
            <van-col span="12" v-if="data.studentInfo && data.studentInfo.orderId" >
              <div class="lineValue breakAll">商城订单号:<span> {{ data.studentInfo.orderId }}</span></div>
            </van-col>
            <van-col span="12" v-if="data.studentInfo && data.studentInfo.outOrderId">
              <div class="lineValue breakAll">外部订单号:<span>  {{ data.studentInfo.outOrderId }}</span></div>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="12">
              <div class="lineValue">已付款:<span> 约合{{ data.diveOrder.currency }} <b>{{ ShowMoney(data.diveOrder.payPrice) }}</b></span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue">总金额:<span> 约合{{ data.diveOrder.currency }} <b>{{ ShowMoney(data.diveOrder.totalPrice) }}</b></span></div>
            </van-col>
          </van-row>
          <div class="lineValue">款项:
            <span v-if="0.01 > Math.abs(data.diveOrder.totalPrice - data.diveOrder.payPrice)"> <b>已结清</b></span>
            <span v-if="data.diveOrder.totalPrice < data.diveOrder.payPrice">已结清 多支付 约合{{ data.diveOrder.currency }} <b>{{ ShowMoney(data.diveOrder.payPrice - data.diveOrder.totalPrice) }}</b></span>
            <span v-if="data.diveOrder.totalPrice > data.diveOrder.payPrice"> 约合{{ data.diveOrder.currency }} <b>{{ ShowMoney(data.diveOrder.totalPrice - data.diveOrder.payPrice) }}</b> 未结清</span>
          </div>
          <div class="lineValue">
            备注:<span>  {{ data.diveOrder.remark }}</span>
          </div>
        </div>
      </div>

      <div v-if="data" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideOnlinePay =!hideOnlinePay">支付尾款</div></van-col>
          <van-col v-if="hideOnlinePay" span="16" class="rigth" @click="hideOnlinePay =!hideOnlinePay">
            <i :class="hideOnlinePay?'iconfont icondownjt':'iconfont iconupjt'" />
          </van-col>
          <van-col v-if="!hideOnlinePay" span="16" class="rigth" @click="hideOnlinePay =!hideOnlinePay"><i :class="hideOnlinePay?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
        </van-row>
        <div v-if="!hideOnlinePay" style="margin-top:0.5em">
          <div v-for="onlinemoney in data.onlineMoneyList" :key="onlinemoney.diveOrderMoneyId" class="onlinepayrect">
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">订单尾款序号:<span> {{ onlinemoney.diveOrderMoneyId }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">支付订单序号:<span> {{ onlinemoney.payOrderId }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="16">
                <div class="lineValue breakAll">订单时间:<span> {{ formatDate(onlinemoney.createTime,'yyyy/MM/dd hh:mm',true) }}</span></div>
              </van-col>
              <van-col span="8">
                <div class="lineValue breakAll">状态:<span> {{ onlinemoney.isWaitPay?'待支付':'已完成支付' }}</span>
                </div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">备注:<span> {{ onlinemoney.remark }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="16">
                <div class="lineValue breakAll">待支付金额:<span>  {{ onlinemoney.currencyReal }} <b>{{ ShowMoney(onlinemoney.priceReal) }}</b></span></div>
              </van-col>
              <van-col span="8">
                <div class="lineValue breakAll">支付:
                  <!-- <van-tag v-if="onlinemoney.isWaitPay" style="color:#fff" :color="GetDiveMainBack()" round @click="onPayOnlineOrder(onlinemoney.diveOrderMoneyId)">微信支付</van-tag> -->
                  <van-button v-if="onlinemoney.isWaitPay" style="color:#fff" :loading="buttonLoading" :color="GetDiveMainBack()" type="primary" size="mini" @click="onPayOnlineOrder(onlinemoney.diveOrderMoneyId)">微信支付</van-button>
                </div>
              </van-col>
            </van-row>

          </div>
          <div class="lineValue breakAll">如果您无法使用“微信支付”请联系客服以其他形式进行支付!</div>
        </div>
      </div>

      <div v-if="data" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideUserInfo =!hideUserInfo">顾客信息</div></van-col>
          <van-col v-if="hideUserInfo" span="16" class="rigth" @click="hideUserInfo =!hideUserInfo">
            <span class="customerInfo">
              <van-tag
                v-if="data.tripType ==='COURSE' &&(!data.studentInfo.birthday||!data.studentInfo.address||!data.studentInfo.headIcon)"
                style="margin-left:0.5em"
                round
                plain
                :color="GetDiveMainBack()"
              >尚未完善信息</van-tag>
              {{ data.studentInfo.firstName }}  {{ data.studentInfo.lastName }}
            </span>
            <i :class="hideUserInfo?'iconfont icondownjt':'iconfont iconupjt'" />
          </van-col>
          <van-col v-if="!hideUserInfo" span="16" class="rigth" @click="hideUserInfo =!hideUserInfo"><i :class="hideUserInfo?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
        </van-row>
        <div v-if="!hideUserInfo" style="margin-top:0.5em">
          <van-row>
            <van-col span="6">
              <van-image
                width="20vw"
                height="26vw"
                fit="cover"
                :src="data.studentInfo.headIcon?data.studentInfo.headIcon:'/img/defaultUserIcon.jpg'"
              /></van-col>
            <van-col span="18">
              <div class="lineValue">姓名:<span> {{ data.studentInfo.firstName }}  {{ data.studentInfo.lastName }}  / {{ data.studentInfo.loaclName }}</span></div>
              <div class="lineValue">生日:<span>{{ data.studentInfo.birthday?formatDate(data.studentInfo.birthday,"yyyy/MM/dd"):'-' }}</span></div>
              <div class="lineValue">邮箱:<span>{{ data.studentInfo.email }} </span></div>
              <div class="lineValue">性别:<span>{{ data.studentInfo.sex }} </span></div>
              <van-button :color="GetDiveMainBack()" size="mini" @click="onCreateBindCode">转移行程</van-button>
              <van-button
                :color="GetDiveMainBack()"
                :disabled="data.studentInfo.state==='Certificateing'||data.studentInfo.state==='Certificate'||data.studentInfo.state==='Success'"
                size="mini"
                @click="onEditCustomerInfo"
              >修改信息</van-button>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="12">
              <div class="lineValue">电话:<span>{{ data.studentInfo.phone }} </span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">社交媒体账号:<span>{{ data.studentInfo.socialMediaAccount }} </span></div>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="12">
              <div class="lineValue">身高:<span>{{ data.studentInfo.height?data.studentInfo.height:'-' }} </span></div>
              <div class="lineValue">鞋码:<span>{{ data.studentInfo.shoeSize?data.studentInfo.shoeSize:'-' }} </span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue">护照号码:<span>{{ data.studentInfo.passportNumber?data.studentInfo.passportNumber:'-' }} </span></div>
              <div class="lineValue">体重:<span>{{ data.studentInfo.weight?data.studentInfo.weight:'-' }} </span></div>
            </van-col>
          </van-row>
          <div class="lineValue">地址:<span>
            {{ data.studentInfo.country }}
            {{ data.studentInfo.cityEng }}
            {{ data.studentInfo.area }}
            {{ data.studentInfo.address }}
            ({{ data.studentInfo.postalCode }})</span></div>
        </div>
      </div>

      <div v-if="data && data.userExpand" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideExpandInfo =!hideExpandInfo">船宿信息</div></van-col>
          <van-col span="16" class="rigth" @click="hideExpandInfo =!hideExpandInfo">
            <span class="customerInfo">
              <van-tag
                v-if="!data.userExpand.isUserLock"
                style="margin-left:0.5em"
                round
                plain
                :color="GetDiveMainBack()"
              >尚未确认信息</van-tag>
            </span>
            <i :class="hideExpandInfo?'iconfont icondownjt':'iconfont iconupjt'" />
          </van-col>
        </van-row>

        <van-row v-if="!hideExpandInfo" style="margin-top:0.5em;">
          <van-col span="12">
            <div class="lineValue breakAll">护照签发地:<span>{{(data.userExpand.passportCountry?data.userExpand.passportCountry:'-')}} </span></div>
          </van-col>
          <van-col span="12">
            <div class="lineValue breakAll">护照有效期:<span>{{(data.userExpand.passportFinish?formatDate(data.userExpand.passportFinish,'yyyy-MM-dd'):'-')}}</span></div>
          </van-col>

          <van-col span="12">
            <div class="lineValue breakAll">保险公司:<span>{{(data.userExpand.insuranceComplane?data.userExpand.insuranceComplane:'-')}}</span></div>
          </van-col>
          <van-col span="12">
            <div class="lineValue breakAll">保险联系电话:<span>{{(data.userExpand.insurancePhone?data.userExpand.insurancePhone:'-')}}</span></div>
          </van-col>
          <van-col span="12">
            <div class="lineValue breakAll">保单号:<span>{{(data.userExpand.insuranceCode?data.userExpand.insuranceCode:'-')}}</span></div>
          </van-col>
          <van-col span="12">
            <div class="lineValue breakAll">备注:<span>{{(data.userExpand.remark?data.userExpand.remark:'-')}}</span></div>
          </van-col>

          <template v-if="data.userExpand.isArriveLock">
            <van-col span="12">
              <div class="lineValue breakAll">抵达接:<span>{{(data.userExpand.arriveType? GetEnumText('Em_PickType',data.userExpand.arriveType) :'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">抵达地:<span>{{(data.userExpand.arriveName?data.userExpand.arriveName:'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">抵达时间:<span>{{(data.userExpand.arriveDate?data.userExpand.arriveDate:'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">抵达号码:<span>{{(data.userExpand.arriveCode?data.userExpand.arriveCode:'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">抵达备注:<span>{{(data.userExpand.arriveRemark?data.userExpand.arriveRemark:'-')}}</span></div>
            </van-col>
          </template>
           <template v-if="data.userExpand.isDepartLock">
            <van-col span="12">
              <div class="lineValue breakAll">离开送:<span>{{(data.userExpand.departType?GetEnumText('Em_PickType',data.userExpand.departType):'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">离开地:<span>{{(data.userExpand.departName?data.userExpand.departName:'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">离开时间:<span>{{(data.userExpand.departDate?data.userExpand.departDate:'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">离开号码:<span>{{(data.userExpand.departCode?data.userExpand.departCode:'-')}}</span></div>
            </van-col>
            <van-col span="12">
              <div class="lineValue breakAll">离开备注:<span>{{(data.userExpand.departRemark?data.userExpand.departRemark:'-')}}</span></div>
            </van-col>
          </template>
          <van-col span="24">
            <div class="lineValue breakAll">租赁装备:
              <span v-if="!data.userExpand.isNeedEquip">未填写</span>
              <span v-if="data.userExpand.isNeedEquip">{{data.userExpand.equipList?data.userExpand.equipList:'-'}}</span>
            </div>
          </van-col>
          <van-col span="12">
            <div class="lineValue breakAll">顾客确认:<span>{{(data.userExpand.isUserLock?'已确认':'待确认')}}</span></div>
          </van-col>
          <van-col span="12">
            <div class="lineValue breakAll">后台确认:<span>{{(data.userExpand.isManageLock?'已确认':'待确认')}}</span></div>
          </van-col>
          <van-col span="24">
             <van-button
                style="float:right"
                :color="GetDiveMainBack()"
                :disabled="data.userExpand.isManageLock"
                size="small"
                @click="onEditLiveAboardInfo"
              >完善信息</van-button>
          </van-col>   
        </van-row>
      </div>


      <div v-if="data && data.equipmentLeaseGroupId" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="onhideEquipmentLease">装备租赁</div></van-col>
          <van-col v-if="hideEquipmentLease" span="16" class="rigth" @click="onhideEquipmentLease">
            <van-tag
              v-if="!data.isHaveInsuranceProduce"
              style="margin-left:0.5em"
              round
              plain
              :color="GetDiveMainBack()"
            >尚未确定装备租赁</van-tag>
            <span v-if="data.isHaveInsuranceProduce" style="font-size: 0.8em;">已确定</span>
            <i :class="hideEquipmentLease?'iconfont icondownjt':'iconfont iconupjt'" />
          </van-col>
          <van-col v-if="!hideEquipmentLease" span="16" class="rigth" @click="onhideEquipmentLease">
            <span v-if="data.isHaveInsuranceProduce" style="font-size: 0.8em;">已确定</span>
            <i :class="hideEquipmentLease?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
        </van-row>

        <div v-if="!hideEquipmentLease && !data.isHaveInsuranceProduce" style="margin-top:0.5em">
          <van-button :color="GetDiveMainBack()" style="width:100%;margin:0.5em 0;" @click="selectEquipmentLeaseStudentId=data.studentInfo.studentId">选择装备租赁</van-button>
          <div class="noticeEquipmentLease">请预先选择您需要租赁的装备，以便我们提前为您准备!</div>
        </div>
        <div v-if="!hideEquipmentLease && data.isHaveInsuranceProduce" style="margin-top:0.5em">
          <van-skeleton :row="6" :loading="loadingEquipmentLease">
            <van-row v-for="(item,index) in diveStudentEquipmentLeaseList" :key="index" class="equipmentLeaseRect">
              <van-col span="14">{{ item.equipmentLeaseId==='0'?'无需租赁':item.title }}
                <van-tag v-if="item.specifications" :color="GetDiveMainBack()">{{ item.specifications }}</van-tag>
              </van-col>
              <van-col span="4">{{ item.count }}{{ item.priceUnit }}</van-col>
              <van-col span="6" style="text-align: right;">{{ item.priceCurrency }}<b>{{ ShowMoney(item.price*item.count) }}</b></van-col>
              <van-col v-if="item.about" span="24" class="about">{{ item.about }}</van-col>
            </van-row>
          </van-skeleton>
          <van-button :color="GetColorSecondary()" style="width:100%" size="small" :loading="buttonLoading" @click="onCancelEquipmentLease">撤销装备租赁需求</van-button>
        </div>
      </div>
      <div v-if="data && !GetIsEnableInsurance() && data.insuranceSelfUrl" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()">保险</div></van-col>
        </van-row>
        <van-button :color="GetDiveMainBack()" class="insuranceSelfUrlButton" size="small" @click="onViewPage(data.insuranceSelfUrl)">前往购买潜水保险</van-button>
      </div>
      <div v-if="data && GetIsEnableInsurance()" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideInsurance =!hideInsurance">保险</div></van-col>
          <van-col span="16" class="rigth" @click="hideInsurance = !hideInsurance">
            <span v-if="data.studentInfo.insuranceImage && !data.studentInfo.insuranceOrderId">图片保单</span>
            <span v-if="data.studentInfo.insuranceOrderId">电子保单</span>
            <span v-if="!data.studentInfo.insuranceImage && !data.studentInfo.insuranceOrderId" style="font-size: 0.8em;">尚未提交</span>
            <i :class="hideInsurance?'iconfont icondownjt':'iconfont iconupjt'" />
          </van-col>
        </van-row>
        <template v-if="!hideInsurance">
          <div v-if="data.studentInfo.insuranceImage" class="insuranceImage">
            <img :src="data.studentInfo.insuranceImage">
          </div>
          <div v-if="insuranceData && insuranceData.order" class="insuranceOrderInfo">
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">保险:<span>  {{ insuranceData.order.productName }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">保障期限:<span> {{ insuranceData.orderInfo.deadlineText }}</span></div>
              </van-col>
            </van-row>
            <van-row v-if="insuranceData.orderInfo">
              <van-col span="12">
                <div class="lineValue breakAll">保单号:<span> {{ insuranceData.order.insureNum }}</span></div>
              </van-col>
              <van-col span="12">
                <div class="lineValue breakAll">保障日期:<span>  {{ insuranceData.orderInfo.deadline }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">
                <div class="lineValue breakAll">生效状态:<span> {{ GetEnumText('Em_EffectiveStatus',insuranceData.order.effectiveStatus) }}</span></div>
              </van-col>
              <van-col span="12">
                <div class="lineValue breakAll">出单状态:<span> {{ GetEnumText('Em_IssueStatus',insuranceData.order.issueStatus) }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">
                <div class="lineValue breakAll">支付状态:<span> {{ GetEnumText('Em_InsurancePayStatus',insuranceData.order.payStatus) }}</span></div>
              </van-col>
              <van-col span="12">
                <div class="lineValue breakAll">支付时间:<span> {{ formatDate(insuranceData.order.createTime,'yyyy/MM/dd',true) }}</span></div>
              </van-col>
            </van-row>
          </div>
          <div class="insuranceOrderButton">
            <van-button :color="GetDiveMainBack()" size="small" @click="onOterInsuranceList">查看其他相近日期保单</van-button>
            <van-button v-if="insuranceData &&insuranceData.product" :color="GetColorSecondary()" size="small" @click="onBuyInsurance(false)">再买一单</van-button>
            <van-button :color="GetDiveMainBack()" size="small" @click="onBuyInsurance(true)">选购保险</van-button>
            <van-button v-if="data.studentInfo.insuranceOrderId && insuranceData && insuranceData.order" :color="GetDiveMainBack()" size="small" @click="onDownLoadInsurance">下载电子保单</van-button>
            <van-button :color="GetColorSecondary()" size="small" @click="onUploadInsuranceImage">上传电子保单截图</van-button>
            <van-button v-if="data.studentInfo.insuranceOrderId && insuranceData && insuranceData.order" :color="GetDiveMainBack()" size="small" @click="onSelectInsurance(data.studentInfo.insuranceOrderId)">查看保险</van-button>
          </div>
        </template>
      </div>
      <div v-if="data && data.studentInfo.cancelState ==='Cancel'" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()"><b>行程终止确认</b></div></van-col>
          <van-col v-if="hideUserInfo" span="16" class="rigth" />
        </van-row>
        <div style="margin-top:0.5em">
          <div class="lineValue">行程状态:<span>{{ GetEnumText("Em_LearningState",data.studentInfo.saveState) }} > <del><b>{{ GetEnumText("Em_LearningState",data.studentInfo.state) }}</b></del></span></div>
          <div class="lineValue">说明:<span>您已经打回教练的行程终止申请。如果疑问请尽快联系教练或者客服!</span></div>
        </div>
      </div>
      <div v-if="data && data.studentInfo.cancelState ==='WaitCheck'" class="baseRest userInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()"><b>行程终止确认</b></div></van-col>
          <van-col v-if="hideUserInfo" span="16" class="rigth" />
        </van-row>
        <div style="margin-top:0.5em">
          <div class="lineValue">行程状态:<span><del>{{ GetEnumText("Em_LearningState",data.studentInfo.saveState) }}</del> > <b>{{ GetEnumText("Em_LearningState",data.studentInfo.state) }}</b></span></div>
          <div class="lineValue">自动确认剩余时间:<span>  <van-count-down v-if="data.studentInfo.cancelState ==='WaitCheck' && data.studentInfo.cancelFinishTimeMSecond>0" class="countDown" :time="data.studentInfo.cancelFinishTimeMSecond" /></span></div>

          <div class="lineValue">说明:<span>您的教练已经申请<b>{{ GetEnumText("Em_LearningState",data.studentInfo.state) }}</b>,请您<b>尽快核实行程进度状态</b>。如果疑问请尽快联系教练或者客服!</span></div>
        </div>
        <van-field
          v-model="confirmStateRemark"
          rows="2"
          autosize
          type="textarea"
          style="padding:0;padding-top:1em;"
          placeholder=">>>如有疑问请输入备注<<<"
        />
        <van-checkbox v-model="checkSuccess" :checked-color="GetDiveMainBack()" class="checkBox">我已经<b>确认状态和进度无误</b>,确定要<b>{{ GetEnumText("Em_LearningState",data.studentInfo.state) }}</b></van-checkbox>
        <van-row gutter="10">
          <van-col span="12"><van-button :disabled="!checkSuccess" :color="GetColorSecondary()" size="small" style="width:100%" :loading="buttonLoading" @click="onConfirmStopState(false)">有异议(打回)</van-button></van-col>
          <van-col span="12"><van-button :disabled="!checkSuccess" :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onConfirmStopState(true)">没问题(认可)</van-button></van-col>
        </van-row>

      </div>

      <div v-if="data && ( data.studentInfo.state==='Finished' || data.studentInfo.state==='Certificateing' || data.studentInfo.state==='Certificate' || data.studentInfo.state==='Success')" class="baseRest userInfo">
        <van-row v-if="data.studentInfo.diveCommentTripId">
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="onComment(data.studentInfo.diveCommentTripId)">查看评价</div></van-col>
          <van-col span="16" class="rigth" @click="onComment(data.studentInfo.diveCommentTripId)">
            <i class="iconfont iconmore" />
          </van-col>
        </van-row>
        <van-row v-if="!data.studentInfo.diveCommentTripId">
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="onComment(null)">立即评价</div></van-col>
          <van-col span="16" class="rigth" @click="onComment(null)">
            <i class="iconfont iconmore" />
          </van-col>
        </van-row>
      </div>

      <div v-if="data && !data.userExpand" class="baseRest">
        <div class="title" :style="'color:'+GetDiveMainBack()">单元</div>
        <div v-for="unit in data.unitList" :key="unit.diveCourseUnitId" class="unitRect">
          <van-row>
            <van-col span="12" class="name">{{ unit.unitName }}</van-col>
            <van-col span="12" class="value rigth">
              <van-tag v-if="unit.state && unit.state!=='FINISH'" round :color="GetDiveMainBack()">{{ GetEnumText("Em_DiveUnitState",unit.state) }}</van-tag>
              <van-tag v-if="unit.state && unit.state==='FINISH'" round :color="GetDiveMainBack()">{{ GetEnumText("Em_CompletionState",unit.completionState) }}</van-tag>

              <van-tag v-if="unit.type==='Theoretical' && unit.eCourseId" style="margin-left:0.5em" round :color="GetDiveMainBack()" @click="onELearn(unit.eCourseId)">进入在线课程</van-tag>
            </van-col>
          </van-row>
          <div class="unitAbout">{{ unit.about }}</div>
          <div v-if="unit.progressLastTime" class="unitComment"><span class="coachName">{{ unit.progressCoachName }}教练:</span>
            {{ unit.progressComment?unit.progressComment:'-' }}
          </div>
          <div v-if="unit.progressLastTime" class="unitDate" :style="'color:'+GetDiveMainBack()">更新时间:{{ formatDate(unit.progressLastTime,'yyyy/MM/dd hh:mm',true) }}</div>
        </div>
      </div>
      <div v-if="data && !data.userExpand" class="baseRest TeamInfo">
        <van-row>
          <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="onTeamClick">队伍信息</div></van-col>
          <van-col v-if="hideTeamInfo" span="16" class="rigth" @click="onTeamClick"><span class="teamName">{{ data.team?data.team.className:'暂未加入' }}</span> <i :class="hideTeamInfo?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
          <van-col v-if="!hideTeamInfo" span="16" class="rigth" @click="onTeamClick"><i :class="hideTeamInfo?'iconfont icondownjt':'iconfont iconupjt'" /></van-col>
        </van-row>
        <van-skeleton title avatar :row="5" :loading="loadingTeam">
          <div v-if="!hideTeamInfo && teamData" style="margin-top:0.5em" class="userInfo">
            <van-row>
              <van-col span="6">
                <van-image
                  width="20vw"
                  height="26vw"
                  fit="cover"
                  :src="(teamData.coach && teamData.coach.icon)?teamData.coach.icon:'/img/defaultUserIcon.jpg'"
                /></van-col>
              <van-col span="18">
                <div class="lineValue">队伍:<span>{{ data.team?data.team.className:'暂未加入' }} </span></div>
                <div class="lineValue">教练:<span>{{ teamData.coach?teamData.coach.proName:'-' }}</span></div>
                <div class="lineValue">教练简介:<span>{{ teamData.coach?teamData.coach.about:'-' }}</span></div>
                <!-- <div class="lineValue">时间:<span>2020-01-01 ~ 2020-01-05</span></div> -->
              </van-col>
            </van-row>

          </div>
          <div v-if="!hideTeamInfo && teamData" class="teamMember">
            <div v-for="(member,index) in teamData.member" :key="index" class="memberRect">
              <van-image
                width="15vw"
                height="15vw"
                round
                fit="cover"
                :src="member.icon?member.icon:'/img/defaultUserIcon.jpg'"
              />
              <div class="name">{{ member.name?member.name:'-' }}</div>
            </div>
          </div>
        </van-skeleton>
      </div>
      <div class="baseRest LogInfo">
        <div class="title" :style="'color:'+GetDiveMainBack()">最新动态</div>
        <van-list
          v-model="loadingLog"
          :finished="finishedLog"
          finished-text="没有更多了"
          @load="onLoadLog"
        >
          <div v-for="log in logList" :key="log.studentLogId" class="LogRect">
            <van-tag mark :color="GetDiveMainBack()">  {{ GetEnumText("Em_DiveStudentLogType",log.type ) }}</van-tag>
            <span class="data">{{ log.body }}</span>
            <span class="date">{{ formatDate(log.createTime,"yyyy/MM/dd hh:mm",true) }}</span>
          </div>
        </van-list>

      </div>
    </van-skeleton>
    <wxShare v-model="showShare" share-title="点击这里通过“发送给朋友”方式私下发送，切记请勿公开分享转移地址以免他人获得您的行程!" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <updateCustomerInfo v-model="selectCustomerInfoStudentId" show-type="student" @reload="init" />
    <tripInsuranceImage v-model="insuranceImageSelect" @reload="init" />
    <tripInsuranceOther v-model="insuranceOtherSelect" @reload="init" />
    <equipmentLease v-model="selectEquipmentLeaseStudentId" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { GetSelfUrl } from '@/utils/request'
import { Button, Image, Tag, Skeleton, List, CountDown, Field, Checkbox, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, getUserBase, MyNotify, ShowMoney, GetEnumText, formatDate, UrlBase64 } from '@/utils/base'
import { GetIsEnableInsurance, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
import updateCustomerInfo from '@/components/updateCustomerInfo'
import equipmentLease from '@/components/equipmentLease'
import tripInsuranceImage from '@/views/divetrip/tripInsuranceImage'
import tripInsuranceOther from '@/views/divetrip/tripInsuranceOther'
import { GetServiceUrlBase } from '@/utils/request'
import { getToken } from '@/utils/auth'

export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton,
    [List.name]: List,
    [CountDown.name]: CountDown,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    TopBar,
    wxShare,
    updateCustomerInfo,
    tripInsuranceImage,
    tripInsuranceOther,
    equipmentLease
  },
  data() {
    return {
      titleTop: '',
      title: '我的行程/课程',
      backurl: '/divetrip',
      hideAbout: true,
      hideUserInfo: true,
      hideExpandInfo:false,
      hideEquipmentLease: true,
      hideInsurance: true,
      hideDiveOrder: true,
      hideOnlinePay: true,
      hideTeamInfo: true,
      loading: true,
      loadingTeam: false,
      id: undefined,
      data: undefined,
      insuranceData: undefined,
      teamData: undefined,
      search: {
        limit: 15,
        page: 1,
        studentId: undefined
      },
      loadingLog: undefined,
      finishedLog: false,
      logList: [],
      buttonLoading: false,
      confirmStateRemark: '',
      checkSuccess: true,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      system: undefined,
      selectCustomerInfoStudentId: undefined,
      insuranceImageSelect: undefined,
      insuranceOtherSelect: undefined,
      selectEquipmentLeaseStudentId: undefined,
      loadingEquipmentLease: false,
      diveStudentEquipmentLeaseList: []
    }
  },

  created() {
    this.data = undefined
    this.insuranceData = undefined
    this.teamData = undefined
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.search.studentId = this.id
    this.system = getUrlKey('system')
    let goto = getUrlKey('goto')
    this.init(() => {
      if(goto ==='liveaboard'){
        this.$router.push('/divetrip/liveaboardexpand/'+this.data.studentInfo.studentId)
      }else if(goto ==='info')
      {
        this.selectCustomerInfoStudentId = this.data.studentInfo.studentId
      }
    })
  },
  methods: {
    GetIsEnableInsurance,
    UrlBase64,
    getToken,
    GetServiceUrlBase,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    onShareFinish() {
      this.shareUrl = undefined
    },
    onELearn(ecourseId) {
      this.$router.push('/divetrip/elearn/' + this.id + '?ecourse=' + ecourseId)
    },
    loadInsurance() {
      request({
        url: '/DiveTrip/getDiveTripInsurance',
        method: 'post',
        data: {
          studentId: this.id,
          isGetList: false
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data.length > 0) {
          this.insuranceData = response.data[0]
          this.insuranceData.orderInfo = JSON.parse(this.insuranceData.order.body)
          this.insuranceData.order.body = undefined
        } else {
          this.insuranceData = undefined
        }
      })
    },
    init(callback) {
      this.hideEquipmentLease = true
      request({
        url: '/DiveTrip/getDiveTrip',
        method: 'post',
        params: {
          id: this.id
        }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        if (this.data.onlineMoneyList.filter(el => el.isWaitPay === true).length > 0) {
          this.hideOnlinePay = false
          MyNotify('info', '您有待支付的尾款，请尽快支付', 5000)
        }

        if (this.data.tripType === 'COURSE' && (!this.data.studentInfo.birthday || !this.data.studentInfo.address || !this.data.studentInfo.headIcon)) {
          Dialog.confirm({
            title: '尚未完善课程认证信息',
            message: '您的行程尚未完善认证信息，请尽快完善个人信息，是否现在完善?',
            confirmButtonText: '去完善',
            cancelButtonText: '稍后完善'
          }).then(() => {
            this.onEditCustomerInfo()
          }).catch(() => {
          })
        } else if (this.data.equipmentLeaseGroupId && !this.data.isHaveInsuranceProduce) {
          Dialog.confirm({
            title: '尚未选择租赁装备',
            message: '您的行程尚未确认租赁装备信息，请尽早选择需要租赁的装备信息，是否现在选择?',
            confirmButtonText: '去选择',
            cancelButtonText: '稍后选择'
          }).then(() => {
            this.selectEquipmentLeaseStudentId = this.data.studentInfo.studentId
          }).catch(() => {
          })
        }
        this.loadInsurance()
        if (callback) {
          callback()
        }
      })
    },
    onTeamClick() {
      if (this.loadingTeam) {
        return
      }
      this.hideTeamInfo = !this.hideTeamInfo
      if (!this.hideTeamInfo && !this.teamData) {
        this.initTeamInfo()
      }
    },
    initTeamInfo() {
      this.loadingTeam = true
      request({
        url: '/DiveTrip/getDiveTripTeamMember',
        method: 'post',
        params: {
          id: this.id
        }
      }).then(response => {
        this.loadingTeam = false
        if (!response.success) {
          return
        }
        this.teamData = response.data
      })
    },
    onLoadLog() {
      console.log('loading', this.loading)
      if (this.loadingLog === undefined) {
        this.loadingLog = true
        return
      }
      this.loadingLog = true
      request({
        url: '/DiveTrip/getDiveTripLogList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loadingLog = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.logList.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finishedLog = true
        }
      })
    },
    onComment(commentId) {
      if (commentId) {
        this.$router.push('/divetrip/tripCommentView/' + this.id)
        // MyNotify('info', '功能暂未完善，敬请期待!', 2000)
        return
      } else {
        this.$router.push('/divetrip/tripComment/' + this.id)
      }
    },
    onConfirmStopState(isRight) {
      this.buttonLoading = true
      request({
        url: '/DiveTrip/StopDiveLearningConfirm',
        method: 'post',
        data: {
          remark: this.confirmStateRemark,
          studentId: this.data.studentInfo.studentId,
          isRight: isRight
        }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        if (isRight) {
          MyNotify('success', '行程已成功终止!', 2000)
          this.data.studentInfo.cancelState = 'None'
        } else {
          MyNotify('info', '行程终止已打回，请联系教练或者客服处理!', 2000)
          this.data.studentInfo.cancelState = 'Cancel'
        }
      })
    },
    onSelectProgress(member, unit, progress) {
      var id
      if (this.selectProgressInfo) {
        id = this.selectProgressInfo.progress.diveProgressId
      }
      this.showStudentProgressInfo = false
      this.selectProgressInfo = undefined
      if (!progress || id === progress.diveProgressId) {
        return
      }
      this.selectProgressInfo = {
        member: member.student,
        unit: unit,
        progress: progress
      }
      this.showStudentProgressInfo = true
    },
    onCreateBindCode() {
      Dialog.confirm({
        title: '转移行程',
        message: '您是否要转移当前行程，注意：一旦转移您当前账号将失去对该行程拥有权!'
      })
        .then(() => {
          Dialog.confirm({
            title: '确认转移行程',
            message: '请妥善分享行程连接给你的伙伴，切勿公开分享。任何人通过分享链接即可转移走您的行程!'
          })
            .then(() => {
              this.onCreateBindCodeDo()
            })
        })
    },
    onEditCustomerInfo() {
      this.selectCustomerInfoStudentId = this.data.studentInfo.studentId
    },
    onEditLiveAboardInfo(){
      this.$router.push('/divetrip/liveaboardexpand/'+this.data.studentInfo.studentId)
    },
    onCreateBindCodeDo() {
      getUserBase((userData) => {
        request({
          url: '/DiveTrip/createNewBindCode',
          method: 'post',
          params: { id: this.data.studentInfo.studentId }
        }).then(Response => {
          if (!Response.success) {
            return
          }
          this.showShare = true
          this.shareTitle = userData.nickName + '转移了行程' + Response.data.courseName + '给你'
          this.shareAbout = '请于' + formatDate(Response.data.lastTime, 'MM/dd hh:mm', true) + '前接收' + formatDate(Response.data.startTime, 'yyyy/MM/dd') + Response.data.courseName
          this.shareTimeline = '请勿通过朋友圈转移行程!'
          this.shareUrl = undefined
          this.shareUrl = GetSelfUrl() + 'divetrip/bind/' + Response.data.hashCode + '/?system=' + this.system
          this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
        })
      })
    },
    onOterInsuranceList() {
      this.insuranceOtherSelect = this.id
    },
    onBuyInsurance(gotoList) {
      if (this.insuranceData && this.insuranceData.product && !gotoList) {
        this.$router.push('/insurance/info/' + this.insuranceData.product.insuranceProductId + '?type=DiveStudent&typeid=' + this.id + '&diveType=' + this.data.insuranceProduceSearch)
      } else {
        this.$router.push('/insurance/list?type=DiveStudent&typeid=' + this.id + '&diveType=' + this.data.insuranceProduceSearch)
      }
    },
    onSelectInsurance(insuranceOrderId) {
      this.$router.push('/insurance/myInfo/' + insuranceOrderId)
    },
    onDownLoadInsurance() {
      var url = GetServiceUrlBase() + '/userAPI/Insurance/PolicyDownload?insuranceOrderId=' + this.insuranceData.order.insuranceOrderId +
      '&token=' + UrlBase64(getToken())
      window.location.href = url
    },
    onUploadInsuranceImage() {
      this.insuranceImageSelect = this.id
    },
    onhideEquipmentLease() {
      this.hideEquipmentLease = !this.hideEquipmentLease
      if (!this.hideEquipmentLease) {
        if (!this.loadingEquipmentLease) {
          this.getDiveStudentEquipmentLeaseList()
        }
      }
    },
    getDiveStudentEquipmentLeaseList() {
      this.loadingEquipmentLease = true
      request({
        url: '/DiveTrip/getDiveStudentEquipmentLeaseList',
        method: 'post',
        params: {
          id: this.data.studentInfo.studentId
        }
      }).then(response => {
        this.loadingEquipmentLease = false
        if (!response.success) {
          return
        }
        this.diveStudentEquipmentLeaseList = response.data
      })
    },
    onCancelEquipmentLease() {
      Dialog.confirm({
        title: '撤销装备租赁需求',
        message: '您是否要撤销装备租赁需求，重新选择?',
        confirmButtonText: '撤销',
        cancelButtonText: '暂不撤销'
      }).then(() => {
        this.onCancelEquipmentLeaseDo()
      }).catch(() => {
      })
    },
    onCancelEquipmentLeaseDo() {
      this.buttonLoading = true
      request({
        url: '/DiveTrip/cleanUserEquipmentLease',
        method: 'post',
        params: {
          id: this.data.studentInfo.studentId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '撤销装备租赁需求成功!', 2000)
        this.init()
      })
    },
    onViewPage(url) {
      window.location.href = url
    },
    onPayOnlineOrder(diveOrderMoneyId) {
      this.buttonLoading = true
      request({
        url: '/DiveTrip/GetDiveTripOnlinePayId',
        method: 'post',
        params: {
          id: diveOrderMoneyId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '支付订单创建成功,正在跳转支付', 2000)
        this.$router.push('/store/pay/0?id=' + response.data)
      })
    },
    
  }
}
</script>
<style scoped>
.baseRest{
    background-color: #fff;
    margin-bottom: 0.5em;
    padding: 1em;
}
.baseRest .title{
    margin-bottom: 0.5em;
}
.baseRest .about{
    font-size: 0.8em;
    margin-top: 0.5em;
}
.baseRest .center{
    margin-top: 0.5em;
}
.baseRest  .name{
    font-size: 0.8em;
    padding-bottom: 0.5em;
}
.baseRest .value{
    font-size: 0.8em;
    color: #999;
}
.baseRest .topLine{
    font-size: 0.9em;
    border-right: 1px solid #f5f5f5;
}
.baseRest .topLine .lineName{
    font-size: 0.9em;
    color: #999;
    margin-bottom: 0.5em;
}

.baseRest .topLine:last-child{
    border-right: 0;
}

.userInfo .lineValue{
    font-size: 0.9em;
    margin-bottom: 0.25em;
     color: #999;
}
.userInfo .lineValue span{
   color: #000;
   margin-left: 0.5em;
}
.baseRest .unitRect:first-child{
    margin-top: 1em;
}
.baseRest .unitRect{
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
    border-bottom: 1px solid #f5f5f5;
}
.baseRest .unitRect:last-child{
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
}
.baseRest .unitRect .unitAbout{
    color: #999;
    font-size: 0.7em;
}
.baseRest .unitRect .unitComment{
margin-top: 0.25em;
font-size: 0.8em;
}
.baseRest .unitRect .unitComment .coachName{
    font-weight: 700;
}

.baseRest .unitRect  .unitDate{
    font-size: 0.7em;
    text-align: right;
    margin-top: 0.25em;
}

.LogInfo .LogRect{
    margin-bottom: 0.25em;
    padding-bottom: 0.25em;
    border-bottom: 1px solid #f5f5f5;
}
.LogInfo .LogRect:last-child{
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
}
.LogInfo .LogRect .data{
    font-size: 0.8em;
    margin-left: 0.5em;
}
.LogInfo .LogRect .date{
    font-size: 0.8em;
    color: #999;
    margin-left: 0.5em;
}

.TeamInfo .teamMember{
    display: flex;
    flex-wrap: wrap;
    text-align: center;

}
.TeamInfo .teamName{
  font-size: 0.8em;
  margin-right: 0.5em;
}
.customerInfo{
  font-size: 0.8em;
  margin-right: 0.5em;
}
.TeamInfo .teamMember .memberRect{
    width: 25%;
        margin-top: 1em;
}
.TeamInfo .teamMember .memberRect .name{
    width: 90%;
    margin-left:5%;
    font-size: 0.8em;
    height: 1em;
    color: #999;
      overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.countDown{
  display: inline;
}
.checkBox{
    padding: 1em 0;
    font-size: 0.7em;
}
.insuranceImage{
  padding-top: 1em;
}
.insuranceImage img{
  width: 100%;
}
.insuranceOrderInfo{
  padding-top: 1em;
}
.insuranceOrderButton button{
  margin-right: 1em;
  margin-top: 0.5em;
}
.noticeEquipmentLease{
  font-size: 0.8em;
  color: #999;
}
.equipmentLeaseRect{
  font-size: 0.8em;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 0.5em;
  padding-bottom: 0.5em;

}
.equipmentLeaseRect .about{
  padding: 0.25em 0;
  color: #999;
  font-size: 0.9em;

}
.insuranceSelfUrlButton{
  margin-top: 1em;
}
.onlinepayrect{
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 0.5em;
  padding-bottom: 0.5em;
}
</style>
